// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__PwbIy","box":"WorkspacesBox_box__36x5y","node":"WorkspacesBox_node__3NBgD"};